import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IProfessionalService } from '../interfaces/profissional/iprofessionalservice';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProfessionalServiceService {
  constructor(private http: HttpClient) {}
  
  getAll() {
    return this.http
      .get(`${environment.url}/services`).pipe(map((res: any) => res['hydra:member'])) as Observable<IProfessionalService[]>;
      //.pipe(map((res: any) => res['hydra:member'])) as Observable<IProfessional[]>;
  }

  getAllByProfessional(professionalId: any) {
    return this.http
      .get(`${environment.url}/services?professional=${professionalId}`).pipe(map((res: any) => res['hydra:member'])) as Observable<IProfessionalService[]>;
      //.pipe(map((res: any) => res['hydra:member'])) as Observable<IProfessional[]>;
  }

  save(req: IProfessionalService) {
    return this.http.post(
      `${environment.url}/services`,
      req
    ) as Observable<IProfessionalService>;
  }

  
  edit(req: IProfessionalService, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `${environment.url}/services/${id}`,
      req,
      { headers: headers }
    ) as Observable<IProfessionalService>;
  }

  delete(id: number) {
    return this.http.delete(
      `${environment.url}/services/${id}`
    ) as Observable<IProfessionalService>;
  }
}
